import React from 'react';
import { Box, SxProps } from '@mui/material';

import { Typography } from '../typography';

type EmptyDataTableProps = {
  testId?: string;
  sx?: SxProps;
  title?: string;
  description?: string;
};

export const EmptyDataTable: React.FC<EmptyDataTableProps> = ({
  testId,
  sx,
  title = 'No data available',
  description = 'There is yet no data to be displayed in this table.',
}) => (
  <Box py={14} color='text.secondary' data-testid={testId} sx={sx}>
    <Typography variant='h6' align='center' paragraph>
      {title}
    </Typography>
    <Typography align='center'>{description}</Typography>
  </Box>
);
